import type { OwnershipResponse } from '@commenda/api';

// UBOs that would be fully removed (BOR cascade-delete) if every inherited
// path from `parentCorporationId` were dropped. A BOR persists when it has
// a direct anchor or any path from another source.
export function previewInheritanceLoss(
  ownership: OwnershipResponse | null | undefined,
  parentCorporationId: number,
): { directorId: number; name: string }[] {
  if (!ownership) return [];
  return ownership.beneficialOwners
    .filter((bo) =>
      bo.paths.some((p) => p.sourceCorporationId === parentCorporationId),
    )
    .filter((bo) => {
      const hasOtherAnchor =
        bo.directControlType != null ||
        bo.paths.some((p) => p.sourceCorporationId !== parentCorporationId);
      return !hasOtherAnchor;
    })
    .map((bo) => ({ directorId: bo.directorId, name: bo.name }));
}

export function formatPersonList(names: string[]): string {
  if (names.length === 0) return '';
  if (names.length === 1) return names[0]!;
  if (names.length === 2) return `${names[0]} and ${names[1]}`;
  return `${names.slice(0, -1).join(', ')}, and ${names[names.length - 1]}`;
}
